import React from "react";
import styles from "./Row.module.sass";
import Checkbox from "../../../../../../components/Checkbox";
import Icon from "../../../../../../components/Icon";
import Actions from "../../../../../../components/Actions";
import Control from "./Control";

const Row = ({ item, value, onChange, onEdit, onDelete }) => {

    const actions = [
        {
            title: "Modifier le candidat",
            icon: "edit",
            action: () => onEdit ? onEdit(item) : console.log("Edit candidate"),
        },
        {
            title: "Supprimer le candidat",
            icon: "trash",
            action: () => onDelete ? onDelete(item.id) : console.log("Delete candidate"),
        },
    ];

    return (
        <>
            <div className={styles.row}>
                <div className={styles.col}>
                    <Checkbox
                        className={styles.checkbox}
                        value={value}
                        onChange={(e) => onChange(e.target.checked)}
                    />
                </div>
                <div className={styles.col}>
                    <div
                        className={styles.item}
                        onClick={() => onEdit ? onEdit(item) : null}
                    >
                        <div className={styles.avatar}>
                            <img src="/images/content/user_logo.png" alt="Candidat" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.product}>{item.first_name} {item.last_name}</div>
                        </div>
                    </div>
                    <Actions
                        className={styles.actions}
                        classActionsHead={styles.actionsHead}
                        items={actions}
                    />
                </div>
                <div className={styles.col}>
                    <div className={styles.contact}>
                        {item.expand?.formation?.exact_title_of_qualification || 'Formation non spécifiée'}
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.contact}>
                        {item.email || 'Email non spécifié'}
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.contact}>
                        {item.phone ? `+${item.phone}` : 'Téléphone non spécifié'}
                    </div>
                </div>
                <div className={styles.col}>
                    <Control
                        className={styles.control}
                        item={item}
                        onDelete={onDelete}
                    />
                </div>
            </div>
        </>
    );
};

export default Row;
